import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["csv", "button"]

  async copy() {
    try {
      await navigator.clipboard.writeText(window.location.href)
      this.buttonTarget.textContent = "Copied"
      this.notify("Link copied to clipboard.")
    } catch (_error) {
      this.notify("Clipboard access was blocked.")
    }
  }

  async copyCsv() {
    try {
      await navigator.clipboard.writeText(this.csvTarget.value)
      this.notify("CSV copied to clipboard.")
    } catch (_error) {
      this.notify("Clipboard access was blocked.")
    }
  }

  notify(message) {
    window.dispatchEvent(new CustomEvent("tinychart:notify", { detail: { message } }))
    window.clearTimeout(this.resetTimeout)
    this.resetTimeout = window.setTimeout(() => {
      this.buttonTarget.textContent = "Copy link"
    }, 1800)
  }
}
